import { useContext, useEffect, useState } from "react";
import { WebrtcContext, exmAddress, exmParams } from "../modules/Webrtc";
import SideComponent from "../Components/SideComponent/SideComponent";
import TabsContainer from "../Components/TabsContainer/TabsContainer";

import "../App.css";
import HeaderMobile from "../Components/Header/headerMobile";
import AllViewComponent from "../Components/MultipleScreen/AllViewComponent";
import OneViewComponent from "../Components/MultipleScreen/OneViewComponent";
// import VideoContainer from "./Components/VideoContainer/VideoContainer";
// import VideoContainerStream from "./Components/VideoContainer/VideoContainerStream";

function PageHome() {
  const {
    isConnectedEXM,
    streamActiveListe,
    streamActive,
    handleAddActiveStream,
  } = useContext(WebrtcContext);
  const [currentWiidth, setIsLargeScreen] = useState(0);
  const [openD, setOpenD] = useState(false);

  const toggleOpenDrawer = () => setOpenD(!openD);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth);
    };

    handleResize(); // Check initial screen width
    window.addEventListener("resize", handleResize); // Listen for resize events

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up the event listener
    };
  }, []);

  return (
    <div className="App">
      <HeaderMobile
        toggleOpenDrawer={toggleOpenDrawer}
        currentWiidth={currentWiidth}
      />
      <div
        style={{
          display: "flex",
          position: "fixed",
          width: "100vw",
          backgroundColor: "black",
          color: "white",
          zIndex: 999,
          paddingBottom: 3,
          paddingLeft: 5,
          fontSize: 10,
        }}
      >
        <label>
          {isConnectedEXM
            ? `Connected to EXM: ${exmAddress}, session=${exmParams.session}`
            : " Connecting..."}
        </label>
      </div>
      <div
        style={
          {
            //backgroundColor: "#090F1C",
            // display: "flex",
            // flexDirection: "row",
            // justifyContent: "space-between",
            // height: "100%",
          }
        }
      >
        <SideComponent
          openD={openD}
          toggleOpenDrawer={toggleOpenDrawer}
          currentWiidth={currentWiidth}
        />
        <div
          className="content"
          style={{
            width: currentWiidth > 980 ? "80%" : "100%",
            paddingTop: 40,
            paddingBottom: currentWiidth > 980 ? 80 : 40,
            marginLeft: currentWiidth > 980 ? "20%" : "0",
          }}
        >
          {streamActive && Object.keys(streamActive).length > 0 ? (
            <OneViewComponent
              streamActiveListe={streamActiveListe}
              handleAddActiveStream={handleAddActiveStream}
            />
          ) : (
            <AllViewComponent
              streamActiveListe={streamActiveListe}
              handleAddActiveStream={handleAddActiveStream}
            />
          )}
          {/* : <VideoContainer currentWiidth={currentWiidth} /> */}
          {streamActive &&
            Object.keys(streamActive).length > 0 &&
            streamActiveListe?.length > 0 && (
              <TabsContainer currentWiidth={currentWiidth} />
            )}
        </div>
      </div>
    </div>
  );
}

export default PageHome;
